import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql'

export enum VariantLabel {
  Amount = 'amount',
  Size = 'size',
}

export const departmentToVariantLabelMap: Record<
  DepartmentsEnum,
  VariantLabel | undefined
> = {
  [DepartmentsEnum.DIGITAL_GIFT_CARDS]: VariantLabel.Amount,
  [DepartmentsEnum.FLOWERS]: VariantLabel.Size,
  [DepartmentsEnum.PLANTS]: VariantLabel.Size,
  [DepartmentsEnum.ALL_FLOWERS_AND_PLANTS]: VariantLabel.Size,
} as Record<DepartmentsEnum, VariantLabel | undefined>
